export interface MedicalRecordPatientSource {
  id: string;
  name: string;
  photo?: { file_path?: string | null } | { file_path?: string | null }[] | null;
  species?: { name?: string | null } | null;
  breed?: { name?: string | null } | null;
  gender?: { name?: string | null } | null;
  owner?: {
    id?: string | null;
    name?: string | null;
    phones?: Array<{
      phone_number?: string | null;
      is_primary?: boolean | null;
      is_whatsapp?: boolean | null;
    }> | null;
  } | null;
}

interface BuildMedicalRecordPatientViewModelArgs {
  pet: MedicalRecordPatientSource;
  age?: string | null;
  lastWeight?: { weight?: number | string | null; measured_at?: string | null } | null;
  locale: string;
}

const resolvePhotoPath = (photo: MedicalRecordPatientSource["photo"]) => {
  if (!photo) return null;
  if (Array.isArray(photo)) return photo[0]?.file_path ?? null;
  return photo.file_path ?? null;
};

export function buildMedicalRecordPatientViewModel({
  pet,
  age,
  lastWeight,
  locale,
}: BuildMedicalRecordPatientViewModelArgs) {
  const primaryPhone =
    pet.owner?.phones?.find((phone) => phone.is_primary) ?? pet.owner?.phones?.[0] ?? null;
  const breedSpecies = [pet.breed?.name, pet.species?.name].filter(Boolean).join(" ");
  const numericWeight = lastWeight?.weight == null ? null : Number(lastWeight.weight);

  return {
    petId: pet.id,
    petName: pet.name,
    photoUrl: resolvePhotoPath(pet.photo),
    ownerId: pet.owner?.id ?? null,
    ownerName: pet.owner?.name ?? null,
    phoneNumber: primaryPhone?.phone_number?.trim() || null,
    phoneIsWhatsApp: primaryPhone?.is_whatsapp === true,
    weightLabel:
      numericWeight == null || Number.isNaN(numericWeight)
        ? null
        : `${new Intl.NumberFormat(locale, { maximumFractionDigits: 2 }).format(numericWeight)} kg`,
    weightMeasuredAt: lastWeight?.measured_at ?? null,
    detailLabels: [pet.gender?.name, breedSpecies || null, age].filter(
      (value): value is string => Boolean(value),
    ),
  };
}
